import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getAtmViaUnitID = (atmId: number | undefined): Promise<IGetAtmViaUnitID[]> => {
  return axiosDefaultApi.get(`/api/Atm/GetAtmsViaUnitID/${atmId}`);
};

type QueryFnType = typeof getAtmViaUnitID;

type UseGetAtmViaUnitIDOptions = {
  atmId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetAtmViaUnitID = ({ atmId , config }: UseGetAtmViaUnitIDOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [`getAtmViaUnitID_${atmId}`],
    queryFn: () => getAtmViaUnitID(atmId),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση του ΑΤΜ via ID.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};